import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { USER_ROLES } from 'utils/roles/types';
import { UserI } from '../../types/types';

interface AuthState {
  user: UserI | null;
  role: USER_ROLES[] | null;
  currentUserId: string | null;
}

const initialState: AuthState = {
  user: null,
  role: null,
  currentUserId: null,
};
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser(state, action: PayloadAction<UserI | null>) {
      state.user = action.payload;
    },
    setRole(state, action: PayloadAction<USER_ROLES[] | null>) {
      state.role = action.payload ? action.payload : null;
    },
    setCurrentUserId(state, action: PayloadAction<string | null>) {
      state.currentUserId = action.payload ? action.payload : null;
    },
  },
});

export const { setUser, setCurrentUserId, setRole } = authSlice.actions;
export default authSlice.reducer;
